import React, { useState, useEffect } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core';
import { HOURS } from '../../../utils/ConstantsMain';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: '8px 8px',
    marginBottom: 0,
  },
  checkbox: {
    paddingLeft: 0,
    paddingRight: 16,
  },
  selectContainer: {
    display: 'flex',
    flexFlow: 'row',
  },
}));

function SelectHour({
  weekDay,
  handleSelectHour,
  start,
  end,
  shift,
  morningEnd,
  membershipType,
}) {
  const classes = useStyles();
  const [hours, setHours] = useState({ start: start, end: end });

  let hourSelectedIndex = HOURS.indexOf(hours.start);
  let closeHours = HOURS.slice(hourSelectedIndex + 1);
  let startHours = HOURS;

  /* morningEnd is a prop received only for evening shift selectHour component */
  if(morningEnd){
    if (morningEnd === '24:00') {
      /* for disabled selects */
      startHours = [''];
      closeHours = [''];
    } else {
      startHours = HOURS.slice(HOURS.indexOf(morningEnd));
    }
  }

  useEffect(() => {
    let newStart = hours;

    if(morningEnd === '24:00'){
      newStart = { ...newStart, start: '', end: '' };
      setHours(newStart);
      handleSelectHour(weekDay, newStart, shift);
    } else {

        if (HOURS.indexOf(start) <= HOURS.indexOf(morningEnd)) {
          
          newStart = { ...newStart, start: startHours[0] };
          
          if (HOURS.indexOf(end) <= HOURS.indexOf(morningEnd)){
            let closeHours =  HOURS.slice( HOURS.indexOf( morningEnd ) + 1)
            newStart = { ...newStart, start: startHours[0], end: closeHours[0] };
          }
          handleSelectHour(weekDay, newStart, shift);
          setHours(newStart);
        }
    } 

  }, [morningEnd]);

  const setOpenHour = (event) => {
    let newHours = hours;
    newHours = { ...newHours, start: event.target.value };

    if (HOURS.indexOf(hours.end) <= HOURS.indexOf(event.target.value)) {
      hourSelectedIndex = HOURS.indexOf(event.target.value);
      closeHours = HOURS.slice(hourSelectedIndex + 1);
      newHours = { ...newHours, end: closeHours[0] };
    }
    setHours(newHours);

    handleSelectHour(weekDay, newHours, shift);
  };

  const setCloseHour = (event) => {
    let newHours = hours;
    newHours = { ...newHours, end: event.target.value };
    setHours(newHours);
    handleSelectHour(weekDay, newHours, shift);
  };

  return (
    <>
      <div className={classes.selectContainer}>
        <FormControl
          variant="outlined"
          className={classes.formControl}
        >
          <Select
            name="start"
            value={start}
            //value={start}
            onChange={setOpenHour}
            style={{ width: isMobile ? 104 : 116 }}
            disabled={morningEnd === '24:00'}
          >
            {startHours &&
              startHours.map((item, index) =>
                item === '24:00' ? null : (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                )
              )}
          </Select>
        </FormControl>
        <FormControl
          variant="outlined"
          className={classes.formControl}
        >
          <Select
            name="end"
            value={end}
            onChange={setCloseHour}
            style={{ width: isMobile ? 104 : 116 }}
            disabled={morningEnd === '24:00'}
          >
            {closeHours &&
              closeHours.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    </>
  );
}

const mapStateToProps = state => ({
  membershipType: state.authClient.membership.type
})

export default connect(mapStateToProps)(SelectHour);